<template>
  <div class="gf-field">
<!--     <VueDatePicker v-model="componentValue" :placeholder="placeholder" format="dd. MM. yyyy. HH:mm" model-type="yyyy-MM-dd HH:mm:ss" /> -->
    <VueDatePicker v-model="componentValue" :placeholder="placeholder" :enableTimePicker="false" :autoApply="true" format="dd. MM. yyyy." model-type="yyyy-MM-dd HH:mm:ss" />
  </div>
</template>

<script>
import { componentMixin } from './FormCommon'
import VueDatePicker from '@vuepic/vue-datepicker';

export default {
  components: { VueDatePicker },
  props: ["placeholder", "type"],
  mixins: [componentMixin],
}
</script>
